module.exports = __webpack_public_path__ + "public/images/Illustration_Social_Emotional_200x174.647c1cfd6968848444124adff3b822b8.png";